// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoAmericanExpress = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M5.704 9.756H4.299L2.61 13.578h1.027L4 12.722h1.963l.364.857h1.917v-2.995l1.366 2.995h.833l1.359-2.995.008 2.995h.931V9.756H11.21l-1.137 2.59-1.233-2.59H7.3v3.612zM4.335 11.93l.647-1.527.646 1.527zm13.048-2.174h-3.79v3.82h3.731l1.202-1.266 1.16 1.266h1.21l-1.76-1.899 1.76-1.92h-1.158l-1.196 1.25zm-2.853 1.49v-.698h2.364l1.031 1.115-1.077 1.122H14.53v-.762h2.066v-.777z"
    />,
    <path
      fillRule="evenodd"
      d="M22.5 3h-21C.672 3 0 3.675 0 4.508v14.318c0 .832.671 1.507 1.5 1.507h21c.828 0 1.5-.675 1.5-1.507V4.508C24 3.675 23.328 3 22.5 3M1.333 14.327L3.741 9H6.2l.32.626V9h2.876l.63 1.375L10.644 9h7.178l.727.812L19.33 9h3.337l-2.416 2.678 2.416 2.655-3.39-.007-.75-.827-.803.827h-6.598v-.661l-.283.662h-1.64l-.283-.649v.648H5.747l-.357-.849h-.817l-.357.85z"
    />
  );
export default SvgIconLogoAmericanExpress;
